import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiChip from "@material-ui/core/Chip";
import classNames from "classnames";
import { Draggable } from "react-drag-and-drop";
import useStyles from "./styles";
export const Chip = props => {
  const {
    id,
    avatar,
    label,
    onDelete,
    className,
    color = "primary",
    variant = "default",
    ...otherProps
  } = props;
  const classes = useStyles(props);
  return /*#__PURE__*/React.createElement(Draggable, {
    type: "label",
    className: classes.draggable,
    data: label
  }, /*#__PURE__*/React.createElement(MuiChip, _extends({
    id: id,
    color: color,
    variant: variant,
    className: classNames("prmbl-chip", className),
    classes: {
      root: classes.root,
      label: classes.label,
      deleteIcon: classes.deleteIcon,
      deletable: classes.deletable
    },
    avatar: avatar,
    label: label,
    onDelete: onDelete,
    deleteIcon: /*#__PURE__*/React.createElement("svg", {
      height: "20",
      width: "20",
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      focusable: "false"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }))
  }, otherProps)));
};
Chip.defaultProps = {
  color: "primary",
  variant: "default"
};
export default Chip;